import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { LoaderService } from '../../../core/services/loader.service';

/** 103 · Cargador de marca a pantalla completa: cápsula con 3 casillas + texto corto + barra. */
@Component({
  selector: 'app-brand-loader',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (message() ?? loader.message(); as text) {
      <div class="veil" role="alert" aria-busy="true">
        <div class="box">
          <div class="capsule">
            <app-stamp-slot class="s s1" color="#F4EAD8" state="filled" />
            <app-stamp-slot class="s s2" color="#F4EAD8" state="filled" />
            <app-stamp-slot class="s s3" color="#F4EAD8" state="empty" />
          </div>
          <p>{{ text }}</p>
          <span class="bar"><i></i></span>
        </div>
      </div>
    }
  `,
  styles: [`
    .veil{position:fixed;inset:0;z-index:var(--cr-z-loader);background:var(--cr-bg-canvas);display:grid;place-items:center;padding:16px}
    .box{width:min(360px, 100%);border-radius:28px;padding:28px;background:#fff;box-shadow:var(--cr-elevation-3);display:flex;flex-direction:column;align-items:center;gap:16px}
    .capsule{display:flex;gap:12px;padding:10px 14px;border-radius:999px;background:#3B2116}
    .s{width:44px;height:44px}
    .s2{animation:stamp 1.1s var(--cr-ease-emphasized) infinite}
    p{margin:0;font:600 18px/24px var(--cr-font-body)}
    .bar{width:100%;max-width:300px;height:6px;border-radius:999px;background:var(--cr-bg-surface-2);overflow:hidden;position:relative}
    .bar i{position:absolute;inset:0 auto 0 0;width:40%;border-radius:inherit;background:var(--cr-brand-teal);animation:slide 1.3s var(--cr-ease-standard) infinite}
    @keyframes stamp{0%{transform:rotate(-12deg) scale(1.08)}40%,100%{transform:none}}
    @keyframes slide{0%{left:-40%}100%{left:100%}}
  `],
})
export class BrandLoaderComponent {
  readonly loader = inject(LoaderService);
  readonly message = input<string | null>(null);
}
